<section class="section why-choose-us" id="about" style="background: white; background-size: cover;margin-top: 5rem;">
  <div class="" style="width: 100%; display:flex;justify-content:center;">
    <!-- <div class="absolute">
        <img src="/assets/images/transition-pattern.png" class="img-responsive relative" />
      </div> -->
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12" style="padding-bottom:10rem !important">
        <div class="title text-center mb-5">
          <div class="row justify-content-center">
            <div class="col-md-8 col-sm-12">
              <h1 class="font-weight-bold main-services-text mb-5">We provide four main Services</h1>
            </div>
          </div>
          <div class="row">
            <ngb-accordion [closeOthers]="true" style="width: 100%;">
              <ngb-panel id="static-1" class="site-accordion">
                <ng-template ngbPanelTitle>
                  <div class="d-flex justify-content-between"
                    style="display:flex !important;justify-content:space-between !important;align-items: center;">
                    <div class="accordion-text">
                      <div class="d-flex text-left">
                        <span class="mr-3">
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_260_55)">
                              <path
                                d="M12.5 7.56201V3.56201H2.5V21.562H22.5V7.56201H12.5ZM6.5 19.562H4.5V17.562H6.5V19.562ZM6.5 15.562H4.5V13.562H6.5V15.562ZM6.5 11.562H4.5V9.56201H6.5V11.562ZM6.5 7.56201H4.5V5.56201H6.5V7.56201ZM10.5 19.562H8.5V17.562H10.5V19.562ZM10.5 15.562H8.5V13.562H10.5V15.562ZM10.5 11.562H8.5V9.56201H10.5V11.562ZM10.5 7.56201H8.5V5.56201H10.5V7.56201ZM20.5 19.562H12.5V17.562H14.5V15.562H12.5V13.562H14.5V11.562H12.5V9.56201H20.5V19.562ZM18.5 11.562H16.5V13.562H18.5V11.562ZM18.5 15.562H16.5V17.562H18.5V15.562Z"
                                fill="#000F66" />
                            </g>
                            <defs>
                              <clipPath id="clip0_260_55">
                                <rect width="24" height="24" fill="white" transform="translate(0.5 0.562012)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                        <span>Outsourced Developer Consultancy</span>
                      </div>

                    </div>
                    <div><svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.7025 17.0264L23.5 25.8047L32.2975 17.0264L35 19.7289L23.5 31.2289L12 19.7289L14.7025 17.0264Z"
                          fill="#212121" />
                      </svg></div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent style="text-align:left">
                  <p><strong>WHAT WE DO</strong></p>
                  <p>We provide full-time and cost-efficient outsourced resources that support your organizational needs
                    in successfully
                    developing a product or executing a project.</p>
                  <p>Some of our Outsourced Development work has included;</p>
                  <ul>
                    <li>Genotype Data Analysis App</li>
                    <li>Beacon Tracking App</li>
                    <li>Wealth Management App</li>
                    <li>Casino Gaming App</li>
                    <li>Business Cards Management App</li>
                    <li>Travel Bookings App</li>
                    <li>Ad platform Distribution App</li>
                    <li>Mortgage App</li>
                    <li>Document Composition Tool</li>
                  </ul>

                  <p>&nbsp;</p>

                  <div class="process-img-1 mb-5">
                    <img class="img-responsive" />
                  </div>


                  <div class="process-img-2 mt-4">
                    <img class="img-responsive" />
                  </div>




                  <p class="mt-3"><strong>CASE STUDY</strong></p>
                  <p><strong>THE ASK</strong></p>
                  <p>We had a client based in the UK operating in the mining sector. Their in-house tech team had
                    stumbled upon a software
                    service idea that, if developed, would increase customer efficiency by 2-4x.</p>
                  <p>Unfortunately, there was no budget allocation to cover the size and capacity of the tech team that
                    would be required
                    to undertake such a complex development. Their in-house tech team, though highly skilled, was
                    staffed just well enough
                    to undertake their daily responsibilities of providing tech support for the business. Thus, it would
                    be nearly
                    impossible to develop the software with their onshore/in-house tech team in the time span required
                    for execution
                    without neglecting their daily duties and throwing them out of balance and out of budget. This
                    software was an
                    afterthought and there was barely a budget allocated for development.</p>
                  <p>Having worked together on previous tech-based projects, we were approached to offer a solution.</p>
                  <p>&nbsp;</p>
                  <p><strong>The Solution</strong></p>
                  <p>We figured right away that they would require a cost-effective yet skilled and motivated tech team
                    that understood
                    the mining industry; would be able to work on their hours; communicate effectively and align
                    relatively quickly to the
                    client&rsquo;s vision. But one that would also be cost-effective.</p>
                  <p>&nbsp;</p>
                  <p><strong>The Execution</strong></p>
                  <p>Using our agile AI system and insight into the mining sector; we were able to select out of our
                    global community of
                    developers and resources; a highly skilled, young, and innovative team whose time zones matched that
                    of the client -
                    [GMT in this case] and who were proficient in English.</p>
                  <p>This would ensure that the collaboration with the client&rsquo;s in-house team would be seamless,
                    with the outsourced
                    team acting as an extension of the in-house team.</p>
                  <p>Our services are generally competitively priced and sensitive to circumstances; thus, we provided a
                    pricing model
                    that was flexible with payment plans that worked for the client&rsquo;s budget.</p>
                  <p>&nbsp;</p>
                  <p><strong>The Result</strong></p>
                  <p>The software was developed, tested, and rolled out 2 weeks ahead of deadline. The collaborative
                    effort with our
                    outsourced team was so successful that the client retained their services to act as an extension of
                    the company&rsquo;s
                    tech support team.</p>

                </ng-template>
              </ngb-panel>
              <ngb-panel id="static-2" class="site-accordion">
                <ng-template ngbPanelTitle>
                  <div class="d-flex justify-content-between"
                    style="display:flex !important;justify-content:space-between !important;align-items: center;">
                    <div class="accordion-text">

                      <div class="d-flex text-left">
                        <span class="mr-3">
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_260_41)">
                              <path
                                d="M8.375 5.68701H19.625V7.93701H21.875V3.43701C21.875 2.19951 20.8625 1.19826 19.625 1.19826L8.375 1.18701C7.1375 1.18701 6.125 2.19951 6.125 3.43701V7.93701H8.375V5.68701ZM17.8362 18.7258L23 13.562L17.8362 8.39826L16.25 9.99576L19.8163 13.562L16.25 17.1283L17.8362 18.7258ZM11.75 17.1283L8.18375 13.562L11.75 9.99576L10.1638 8.39826L5 13.562L10.1638 18.7258L11.75 17.1283ZM19.625 21.437H8.375V19.187H6.125V23.687C6.125 24.9245 7.1375 25.937 8.375 25.937H19.625C20.8625 25.937 21.875 24.9245 21.875 23.687V19.187H19.625V21.437Z"
                                fill="#000F66" />
                            </g>
                            <defs>
                              <clipPath id="clip0_260_41">
                                <rect width="27" height="27" fill="white" transform="translate(0.5 0.0620117)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                        <span>Application & Software Development</span>
                      </div>
                    </div>
                    <div><svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.7025 17.0264L23.5 25.8047L32.2975 17.0264L35 19.7289L23.5 31.2289L12 19.7289L14.7025 17.0264Z"
                          fill="#212121" />
                      </svg></div>
                  </div>

                </ng-template>
                <ng-template ngbPanelContent>
                  <p>From conceptualization to design to launch; If you are looking for top-notch software development
                    services, look no
                    further than our team of experts. We have a proven track record of delivering quality software
                    solutions that meet the
                    needs of our clients. We're committed to providing the best possible service and value for your
                    money.</p>
                  <p>&nbsp;</p>
                  <p>Our Application&amp; Software Development portfolio includes;</p>
                  <ul>
                    <li>Book Inventory App</li>
                    <li>Pipe Measuring App</li>
                    <li>Non-destructive Pipe Testing Data Collection App</li>
                    <li>Catalytic Converter App</li>
                    <li>Catalytic Converter App</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><strong>OUR DEVELOPMENT PROCESS</strong></p>

                  <div class="process-img-3">
                    <img class="img-responsive" />
                  </div>

                  <p>&nbsp;</p>
                  <p><strong>CASE STUDY</strong></p>
                  <p>THE ASK</p>
                  <p>A tubular testing company in the oil and gas industry had experienced an unexpected growth spurt
                    the previous year;
                    their customer base had grown by up to 10x. Way above the capacity they were equipped to handle at
                    the time.</p>
                  <p>They found themselves monitoring millions of casing pipes from various customers across various
                    testing facilities.
                    It was becoming quite a bottleneck for their operational flow. And with the occurrence of the BP oil
                    spill; their
                    monitoring challenges had quickly become a major problem.</p>
                  <p>They had the knowledge; they had the processes and workflows; but the logistics and demand increase
                    were creating
                    huge pressure on their hard paper process and excel sheet models.</p>
                  <p>Bemddops was approached to find and develop a commonsense tech-based solution to this quagmire.</p>
                  <p>&nbsp;</p>
                  <p><strong>THE SOLUTION</strong></p>
                  <p>First off, our business analysts spent 14 working days on the factory floor walking through case
                    scenarios with their
                    team; primarily to gain a deeper insight into the nature and workflow of the business.</p>
                  <p>We then proceeded to map out their workflow visually and identified the intrinsic bottlenecks in
                    their processes. Our
                    team was able to identify specific areas where work orders could be shut down or closed or moved up
                    in priority
                    because we had built data models that could catch a variety of pain points early on.</p>
                  <p>Armed with this insight, we provided a more efficient workflow plan which then formed the basis to
                    build a
                    tailor-made software solution for the business.</p>
                  <p>&nbsp;</p>
                  <p><strong>THE RESULTS</strong></p>
                  <p>Our data models and software solution saved the company 15% in operating costs in the very first
                    year.</p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="static-3" class="site-accordion">
                <ng-template ngbPanelTitle>
                  <div class="d-flex justify-content-between"
                    style="display:flex !important;justify-content:space-between !important;align-items: center;">
                    <div class="accordion-text">
                      <div class="d-flex text-left">
                        <span class="mr-3">
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_260_65)">
                              <path
                                d="M14.5 12.562L12.5 14.562L10.5 12.562L12.5 10.562L14.5 12.562ZM12.5 6.56201L14.62 8.68201L17.12 6.18201L12.5 1.56201L7.88 6.18201L10.38 8.68201L12.5 6.56201ZM6.5 12.562L8.62 10.442L6.12 7.94201L1.5 12.562L6.12 17.182L8.62 14.682L6.5 12.562ZM18.5 12.562L16.38 14.682L18.88 17.182L23.5 12.562L18.88 7.94201L16.38 10.442L18.5 12.562ZM12.5 18.562L10.38 16.442L7.88 18.942L12.5 23.562L17.12 18.942L14.62 16.442L12.5 18.562Z"
                                fill="#000F66" />
                            </g>
                            <defs>
                              <clipPath id="clip0_260_65">
                                <rect width="24" height="24" fill="white" transform="translate(0.5 0.562012)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                        <span>In-Person & Online Trainings</span>
                      </div>

                    </div>
                    <div><svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.7025 17.0264L23.5 25.8047L32.2975 17.0264L35 19.7289L23.5 31.2289L12 19.7289L14.7025 17.0264Z"
                          fill="#212121" />
                      </svg></div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p><strong> In-Person Trainings &amp; Online Trainings </strong></p>
                  <p>
                    In the heart of Africa's dynamic growth and transformation lies the need for expertise across pivotal sectors. 
                    Bemddops is dedicated to nurturing this expertise, with training programs that resonate with Africa's unique challenges and opportunities.
                  </p>
                  <p><strong>Oil & Gas Trainings;</strong> </p>
                  <p>Foundational Program;</p>
                  <ul>
                    <li>On-demand training focusing on Africa's Oil & Gas landscape.</li>
                    <li>Advanced courses delve into the continent's Petroleum Extraction techniques and Refinery Operations.</li>
                  </ul>
                  <p>Advanced Skill Program;</p>
                  <ul>
                    <li>Full-time courses on Upstream Processes, tailored to Africa's exploration and production challenges.</li>
                    <li>Comprehensive training on Downstream Processes, with a focus on local refining and distribution systems.</li>
                    <li>Part-time courses on Midstream Operations, considering the continent's infrastructural nuances.</li>
                  </ul>

                  <p><strong>Safety & EHS (Environmental, Health, and Safety) Training;</strong> </p>
                  <p>Beginner's Program;</p>
                  <ul>
                    <li>On-demand training on Safety Protocols, considering Africa's diverse environmental and industrial backdrop.</li>
                    <li>Advanced courses on Hazard Recognition specific to the continent's industries.</li>
                  </ul>
                  <p>Specialized Program;</p>
                  <ul>
                    <li>Full-time courses on Environmental Impact Assessments, with a focus on Africa's unique ecosystems.</li>
                    <li>Training on Health Risk Management, considering local health challenges and industrial practices.</li>
                  </ul>

                  <p><strong>Construction Training;</strong> </p>
                  <p>Core Program;</p>
                  <ul>
                    <li>On-demand training on Construction Fundamentals, tailored for Africa's growing urbanization.</li>
                    <li>Advanced courses on Structural Engineering and Project Management, considering local materials and techniques.</li>
                  </ul>
                  <p>Expertise Program;</p>
                  <ul>
                    <li>Full-time courses on Modern Construction Techniques suitable for Africa's climate and geography.</li>
                    <li>Part-time training on Sustainable Building Practices, emphasizing eco-friendly construction in the African context.</li>
                  </ul>

                  <p><strong>Software & Technology Training;</strong> </p>
                  <p>PreSkill Program;</p>
                  <ul>
                    <li>On-demand training in Coding Fundamentals, considering the growing tech ecosystem in Africa.</li>
                    <li>Advanced courses offer an introduction to Web Development and Software tailored to the continent's digital transformation.</li>
                  </ul>
                  <p>ReSkill Program;</p>
                  <ul>
                    <li>Full-time courses in technologies like .NET C# and Java, with a focus on applications relevant to Africa's industries.</li>
                    <li>Part-time courses in Advanced Software Development, considering the unique tech challenges and opportunities in the continent.</li>
                  </ul>

                  <p><strong>Our Courses are Designed for;</strong> </p>
                  <p>Corporate Training;</p>
                  <ul>
                    <li>African enterprises aiming to empower their teams, driving local innovation and global competitiveness.</li>
                  </ul>
                  <p>Individuals;</p>
                  <ul>
                    <li>Ambitious learners from across the continent, eager to make a mark in their chosen field and contribute to Africa's bright future.</li>
                  </ul>



                </ng-template>
              </ngb-panel>
              <ngb-panel id="static-4" class="site-accordion">
                <ng-template ngbPanelTitle>
                  <div class="d-flex justify-content-between"
                    style="display:flex !important;justify-content:space-between !important;align-items: center;">
                    <div class="accordion-text">

                      <div class="d-flex text-left">
                        <span class="mr-3">
                          <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_260_76)">
                              <path
                                d="M9.9 17.162L5.3 12.562L9.9 7.96201L8.5 6.56201L2.5 12.562L8.5 18.562L9.9 17.162ZM15.1 17.162L19.7 12.562L15.1 7.96201L16.5 6.56201L22.5 12.562L16.5 18.562L15.1 17.162V17.162Z"
                                fill="#000F63" />
                            </g>
                            <defs>
                              <clipPath id="clip0_260_76">
                                <rect width="24" height="24" fill="white" transform="translate(0.5 0.562012)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                        <span> Hackathons</span>
                      </div>

                    </div>
                    <div><svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.7025 17.0264L23.5 25.8047L32.2975 17.0264L35 19.7289L23.5 31.2289L12 19.7289L14.7025 17.0264Z"
                          fill="#212121" />
                      </svg></div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>Bemddops aims to inspire &amp; equip developers to build great software by curating an ecosystem
                    where every
                    developer who wants to improve their craft or be inspired to build, can thrive with us.</p>
                  <p>Thus, we power a series of software competitions through our vast global community of partners and
                    innovation labs.
                  </p>
                  <p>Competitions inspire developers uniquely for several reasons:</p>
                  <ul>
                    <li>Deadlines create urgency</li>
                    <li>The best learning comes from building</li>
                    <li>Prizes are awarded without taking developer IP</li>
                    <li>Accomplishing a personal challenge brings satisfaction</li>
                  </ul>
                  <p>If you&rsquo;re a developer looking to be inspired, get in touch with us,</p>
                  <p>For customers, there are three parts to our offering:</p>
                  <ol>
                    <li>Our large, global community</li>
                    <li>Our experienced services team</li>
                    <li>Our innovation labs across the world</li>
                  </ol>
                  <p>We&rsquo;re fortunate to have a broad customer base that includes corporations of all sizes,
                    non-profits, government
                    agencies, and universities. If you&rsquo;re a potential customer, we&rsquo;d love to hear from you.
                  </p>
                  <p>&nbsp;</p>

                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="svg-container-2">
    <svg viewBox="0 0 1440 125" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="222" rx="808.5" ry="222" fill="#34E3B2" />
    </svg>
  </div>
</section>
